module.exports = __webpack_public_path__ + "img/A-881-900.150572c0.svg";